import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SplitTaskDialogComponent, SplitTaskDialogResult } from "src/app/shared-module/components/split-task-dialog/split-task-dialog.component";
import { ToastService } from '../../../core/services/toast/toast.service';

/** `executeCommand` answers with the scalar `CommandExecutionResult`; `result` carries its state. */
const COMMAND_RESULT_ERROR = 'ERROR';

@Injectable({
    providedIn: 'root'
  })
export class SplitCompositTaskCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService,
    private router: Router,
    private toastService: ToastService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(SplitTaskDialogComponent, {
        width: "500px",
        header: commandTemplate?.settings?.label,
        data: {
          commandTemplate: commandTemplate,
        }
      });
      this.dialogRef.onClose.subscribe((result: SplitTaskDialogResult | false) => {
        if(result){
          commandInput.addParameter("protocolIds", result.protocolIds);
          commandService.sendCommand(commandInput, (response) => {
            // The server rejects an empty selection or foreign protocol ids with
            // an ERROR result and changes nothing. Its error text is technical,
            // so we show our own message and skip the completion behavior.
            if (response?.data?.executeCommand?.result === COMMAND_RESULT_ERROR) {
              this.toastService.addErrorToast('sharedModule.splitTaskDialogComponent.errorToastMessage');
              return;
            }
            // Navigate to tasks list if current URL shows a specific task
            // When all protocols are split off, the task we showed may be
            // deleted, so we navigate back to the tasks list
            // As long as we do not have the side panel overview implemented everywhere
            // we must filter the cases manually
            const currentUrl = this.router.url;
            const taskDetailPattern1 = /\/tasks\?type=task&show=[a-f0-9-]+/;
            const taskDetailPattern2 = /\/tasks\/task\/[a-f0-9-]+/;
            
            if (taskDetailPattern1.test(currentUrl) || taskDetailPattern2.test(currentUrl)) {
              this.router.navigate(['/tasks']);
            }
            
            completionCallback();
          })
        }
      });

    
  }
  
}